import React from 'react'
import Button from '@material-ui/core/Button';
import { NavLink } from 'react-router-dom';
const Puz20 = () => {
    return (
        <div>
               <NavLink to='/category/Puzzels/Puzzel21'>
<Button variant="contained" color="primary" style={{float:'right', margin:'25px',marginRight:'80px'}}>Next page -&gt; </Button>
</NavLink> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
<NavLink to='/category/Puzzels/Puzzel19'>
<Button variant="contained" color="primary" style={{float:'left', margin:'25px',marginLeft:'70px'}}>&lt;-   Previous page </Button>
</NavLink>
<article class="container">
    <h1 class="title">5 Pirates and 100 Gold Coins</h1>
   
   
    <div class="text">
        <p>There are 5 pirates, they must decide how to distribute 100 gold coins among them. The pirates have seniority
            levels, the senior-most is A, then B, then C, then D, and finally the junior-most is E.&nbsp;</p>
        <p>Rules of distribution are:&nbsp;</p>
        <ol>
            <li>The most senior pirate proposes a distribution of coins.</li>
            <li>All pirates vote on whether to accept the distribution.</li>
            <li>The distribution is approved if at least half of the pirates agree (including the proposer)</li>
            <li>If the distribution is accepted, the coins are disbursed and the game ends.</li>
            <li>If not, the proposer is thrown and dies, and the next most senior pirate makes a new proposal to begin
                the system again.</li>
            <li>In case of a tie vote, the proposer can have the casting vote</li>
        </ol>
        <p>Rules every pirate follows.</p>
        <ol>
            <li>Every pirate wants to survive</li>
            <li>Given survival, each pirate wants to maximize the number of gold coins he receives.</li>
        </ol>
        <p><strong>What is the maximum number of coins that pirate A might
                get?</strong>&nbsp;<br/>
                <div class="container">
                <strong>Answer:</strong>&nbsp;<br/>
                The answer is 98 which is not
            intuitive.&nbsp;<br/>
            A uses the facts below to get 98.&nbsp;
        <ol>
            <li>Consider the situation when A, B, and C die, only D and E are left. E knows that he will not get
                anything (D is senior and will make a distribution of <strong>(100, 0)</strong>. So E would be fine with
                anything greater than 0.</li>
            <li>Consider the situation when A and B die, C, D, and E are left. D knows that he will not get anything (C
                will make a distribution of <strong>(99, 0, 1)</strong>and E will vote in favor of C).</li>
            <li>Consider the situation when A dies. B, C, D, and E are left. To survive, B only needs to give 1 coin to
                D. So distribution is <strong>(99, 0, 1, 0)</strong></li>
            <li>Similarly, A knows about point 3, so he just needs to give 1 coin to C and 1 coin to E to get them in
                favor. So distribution is <strong>(98, 0, 1, 0, 1)</strong>.</li>
        </ol>
      </div></p>
    </div>
</article>
        </div>
    )
}

export default Puz20
